import { Database, Rows3 } from "lucide-react";
import { useTranslation } from "@ncp/i18n";
import { Badge, StatCard } from "@ncp/ui";
import { CatalogPage } from "../features/generic/CatalogPage";
import { newRecordTypeBody, type RecordTypeBody, type RecordTypeSummary } from "../features/records/api";

/** Record types: the data model an admin defines without code – fields, links and checks – with the records staff keep in each. */
export function RecordTypesPage() {
  const { t } = useTranslation();
  return (
    <CatalogPage<RecordTypeSummary, RecordTypeBody>
      resource="record-types"
      basePath="/data"
      icon={Database}
      title={t("admin:recordTypes.title")}
      subtitle={t("admin:recordTypes.subtitle")}
      navLabel={t("admin:nav.data")}
      writePermission="platform.recordtypes.write"
      newLabel={t("admin:recordTypes.new")}
      emptyTitle={t("admin:recordTypes.emptyTitle")}
      emptyBody={t("admin:recordTypes.emptyBody")}
      docsAnchor="record-types"
      help={<><p>{t("admin:recordTypes.help.what")}</p><p>{t("admin:recordTypes.help.checks")}</p><p>{t("admin:recordTypes.help.extension")}</p></>}
      newBody={(name, nameAr) => newRecordTypeBody(name, nameAr)}
      stats={(rows) => <StatCard label={t("admin:recordTypes.stats.records")} value={rows.reduce((n, r) => n + (r.recordCount ?? 0), 0)} icon={Rows3} tone="neutral" footer={t("admin:recordTypes.stats.recordsHint")} />}
      columns={[
        { header: t("admin:recordTypes.columns.fields"), cell: (r) => <span className="tabular-nums">{r.fieldCount}</span> },
        { header: t("admin:recordTypes.columns.records"), cell: (r) => <span className="tabular-nums">{r.recordCount}</span> },
        { header: t("admin:recordTypes.columns.owner"), cell: (r) => r.extendsServiceKey ? <Badge variant="camel" size="sm">{t("admin:recordTypes.extends", { service: r.extendsServiceKey })}</Badge> : r.departmentKey ? <Badge variant="outline" size="sm">{r.departmentKey}</Badge> : <Badge variant="info" size="sm">{t("admin:recordTypes.shared")}</Badge> },
      ]}
    />
  );
}
